import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppStartupState } from "../../shared/enums/AppStartupState";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export interface LicenseModalState {
  isOpen: boolean;
  status: ApiResponseStatus | null;
  message: string;
}

export interface AppStatusState {
  startupState: AppStartupState;
  startupMessage: string;
  loadingInstitutionSetup: boolean;
  errorSetupInstitution: string | null;
  isSetupComplete: boolean | null;
  loadingSetupCheck: boolean;
  loadingLicenseRevalidate: boolean;
  licenseModal: LicenseModalState;
}

const initialState: AppStatusState = {
  startupState: AppStartupState.LOADING,
  startupMessage: "Checking system initialization...",
  isSetupComplete: null,
  loadingInstitutionSetup: false,
  errorSetupInstitution: null,
  loadingSetupCheck: false,
  loadingLicenseRevalidate: false,
  licenseModal: {
    isOpen: false,
    status: null,
    message: "",
  },
};

export const appStatusSlice = createSlice({
  name: "appStatus",
  initialState,
  reducers: {
    setStartupState(
      state,
      action: PayloadAction<{ state: AppStartupState; message?: string }>,
    ) {
      state.startupState = action.payload.state;
      state.startupMessage = action.payload.message || "";
    },
    setSetupComplete(state, action: PayloadAction<boolean>) {
      state.isSetupComplete = action.payload;
      state.startupState = action.payload
        ? AppStartupState.READY
        : AppStartupState.NEEDS_SETUP;
    },
    setLoadingSetupCheck(state, action: PayloadAction<boolean>) {
      state.loadingSetupCheck = action.payload;
    },
    setLoadingInstitutionSetup(state) {
      state.loadingInstitutionSetup = true;
      state.errorSetupInstitution = null;
    },
    setErrorSetupInstitution(state, action: PayloadAction<string | null>) {
      state.loadingInstitutionSetup = false;
      state.errorSetupInstitution = action.payload;
    },
    institutionSetupSuccess(state) {
      state.loadingInstitutionSetup = false;
      state.errorSetupInstitution = null;
    },
    setLoadingLicenseRevalidate(state, action: PayloadAction<boolean>) {
      state.loadingLicenseRevalidate = action.payload;
    },
    showLicenseModal(
      state,
      action: PayloadAction<{ status: ApiResponseStatus; message: string }>,
    ) {
      state.licenseModal = {
        isOpen: true,
        status: action.payload.status,
        message: action.payload.message,
      };
    },
    closeLicenseModal(state) {
      state.licenseModal = {
        isOpen: false,
        status: null,
        message: "",
      };
    },
  },
});

export const appStatusActions = appStatusSlice.actions;
export default appStatusSlice.reducer;
